import React, { useState } from 'react'
import styles from './Index.module.css';
import Logo from '../../../assets/logo.png'
import UserItem from './UserItem';
import Loader from './Loader';


const Userlist = ({ allData, isLoading, isPropertyOpen, setIsPropertyOpen }) => {


    return (
        <div className={styles.userList}>
            <div>
                <img src={Logo} style={{ width: 300 }} />
            </div>
            <div className={styles.userListBox}>
                {isLoading ? <div style={{ fontSize: 17 }}>Loading...</div> : allData?.property?.length === 0 ? <div style={{ height: 170, width: "100%", display: "flex", justifyContent: "center", alignItems: "center", fontSize: 16 }}>User has not created any property.</div> : allData?.property?.map((property, index) => <div key={property._id} className={styles.userListBox}> <UserItem key={index} property={property} allData={allData} isPropertyOpen={isPropertyOpen} setIsPropertyOpen={setIsPropertyOpen} /> </div>)}

            </div>
        </div>
    )
}

export default Userlist